'use strict';

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

require('node-forge/lib/rsa');

var forge = require('node-forge/lib/forge');

var _require = require('../util'),
    base64urlToBigInteger = _require.base64urlToBigInteger;

function convert(key, types) {
  return types.map(function (t) {
    return base64urlToBigInteger(key[t]);
  });
}

function jwk2priv(key) {
  var _forge$pki;

  return (_forge$pki = forge.pki).setRsaPrivateKey.apply(_forge$pki, _toConsumableArray(convert(key, ['n', 'e', 'd', 'p', 'q', 'dp', 'dq', 'qi'])));
}

function jwk2pub(key) {
  var _forge$pki2;

  return (_forge$pki2 = forge.pki).setRsaPublicKey.apply(_forge$pki2, _toConsumableArray(convert(key, ['n', 'e'])));
}

module.exports = {
  jwk2pub: jwk2pub,
  jwk2priv: jwk2priv
};